import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e8b44df"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notch" }, null, -1))
const _hoisted_2 = { class: "status-bar-container" }

import SlideItem from "@/components/organisms/common/HowToGuide/SlideItem.vue";
import { AbTest3113 } from "@/app/services/AbTestService";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";
import { authStore } from "@/store/auth";
import { deviceModule } from "@/store/device";
import { scrollToTop } from "@/utils/scrollUtil";
import { onMounted, computed } from "vue";
import { ref } from "vue";
// @ts-ignore
import slide01Src from "@/assets/svg/Onboarding/how-to-use-slide01.svg?webp&width=560";
// @ts-ignore
import slide02Src from "@/assets/svg/Onboarding/how-to-use-slide02.svg?webp&width=560";
// @ts-ignore
import slide03Src from "@/assets/svg/Onboarding/how-to-use-slide03.svg?webp&width=560";
// @ts-ignore
import slide04Src from "@/assets/svg/Onboarding/how-to-use-slide04.svg?webp&width=560";


export default /*#__PURE__*/_defineComponent({
  __name: 'HowToGuide',
  emits: ["close"],
  setup(__props, { emit }) {



const slide = ref(0);
const isBrowser = deviceModule.isBrowser;
const slides = [slide01Src, slide02Src, slide03Src, slide04Src];
const howToGuide = ref<HTMLElement | null>(null);

const closeHowToGuide = () => {
  sendAdjustEvent("CLOSE_HOW_TO_GUIDE");
  sendFirebaseCustomEvent("close_how_to_guide", {
    session_id: authStore.sessionId || "unknown"
  });
  emit("close");
};

const isAbTest3113Group = computed(() => {
  return AbTest3113.getTestGroup() !== "A";
});

onMounted(() => {
  AbTest3113.registerEvent(AbTest3113.eventTypes.entryHowToGuide);
  sendAdjustEvent("SHOW_HOW_TO_GUIDE");
  sendFirebaseCustomEvent("show_how_to_guide", {
    session_id: authStore.sessionId || "unknown"
  });
  if (isAbTest3113Group.value) {
    closeHowToGuide();
  }
});

const onClickSlide = () => {
  if (slide.value === slides.length - 1) {
    // 最後のスライドをクリックした場合
    closeHowToGuide();
    return;
  }

  slide.value++;
  if (howToGuide.value) {
    scrollToTop(howToGuide.value, { duration: 0 });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BCarouselSlide = _resolveComponent("BCarouselSlide")!
  const _component_BCarousel = _resolveComponent("BCarousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createTextVNode(),
    _createElementVNode("div", {
      class: _normalizeClass(["how-to-guide", { 'is-browser': _unref(isBrowser) }]),
      ref_key: "howToGuide",
      ref: howToGuide
    }, [
      _createVNode(_component_BCarousel, {
        modelValue: slide.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((slide).value = $event)),
        "no-wrap": "",
        "no-animation": "",
        interval: 0
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (slideItemSrc, index) => {
            return _createVNode(_component_BCarouselSlide, { key: index }, {
              img: _withCtx(() => [
                _createElementVNode("div", {
                  class: "svg-container",
                  onClick: onClickSlide
                }, [
                  _createVNode(SlideItem, { src: slideItemSrc }, null, 8, ["src"])
                ])
              ]),
              _: 2
            }, 1024)
          }), 64))
        ], undefined, true),
        _: 1
      }, 8, ["modelValue"]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slides.length, (number) => {
          return (_openBlock(), _createElementBlock("div", {
            key: number,
            class: _normalizeClass(["status-bar", { 'status-bar-active': number - 1 === slide.value }])
          }, null, 2))
        }), 128))
      ])
    ], 2)
  ], 64))
}
}

})